import { useQuery } from '@tanstack/react-query';
import { getActiveAccessIssuesForProperty, getUrgentAccessIssues, getAccessIssues } from '../service';
import { AccessIssueFilters } from '../types/filters';

function useActiveAccessIssuesForProperty(propertyId: number) {
    const query = useQuery({
        queryKey: ['property', propertyId, 'access-issues'],
        queryFn: () => getActiveAccessIssuesForProperty(propertyId),
    });

    return query;
}

function usePropertyAccessIssues(propertyId: number) {
    const query = useQuery({
        queryKey: ['property', propertyId, 'access-issues'],
        queryFn: async () => {
            const results = await getAccessIssues({
                facets: [],
                query: null,
                propertyManager: null,
                propertyId,
            }, 1, 1);

            if (results.items.length === 0) return null;
            return results.items[0];
        },
    });

    return query;
}

function useAccessIssues(
    filters: AccessIssueFilters,
    pageNumber: number,
    pageSize: number,
    {
        isEnabled = true,
    }: {
        isEnabled?: boolean;
    } = {}
) {
    const query = useQuery({
        queryKey: ['access-issues', filters, pageNumber, pageSize],
        queryFn: () => getAccessIssues({ ...filters }, pageNumber, pageSize),
        enabled: isEnabled,
    });

    return query;
}

function useUrgentAccessIssues(
    propertyManagerId?: string
) {
    const query = useQuery({
        queryKey: ['dashboard', 'tab', 'access-issues', propertyManagerId],
        queryFn: () => getUrgentAccessIssues(propertyManagerId),
    });

    return query;
}

export {
    useActiveAccessIssuesForProperty,
    useAccessIssues,
    useUrgentAccessIssues,
    usePropertyAccessIssues,
};
